<section>
    <h2>How to Buy Reyna</h2>
    <p>Buying crypto can seem difficult, but it shouldn't be that way!</p>
    <p>You can swap Reyna Coin from a number of DeFi platforms on Solana. Check out the links below!</p>
    <div class="buy-links-container">
        <div class="buy-link">
            <a style="background: #1c2936;" href="https://jup.ag/swap/SOL-4zyE51eWthh21ZNBB5rymdV3Pgen2DXH7HiLdfi2AKtX" target="_blank" rel="noopener noreferrer" class="buy-button">
                <img src="https://jup.ag/svg/jupiter-logo.svg" alt="Jupiter" class="button-image"/>
                <span class="button-text">Jupiter</span>
            </a>
        </div>

        <div class="buy-link">
            <a style="background: #000000;" href="https://birdeye.so/token/4zyE51eWthh21ZNBB5rymdV3Pgen2DXH7HiLdfi2AKtX?chain=solana" target="_blank" rel="noopener noreferrer" class="buy-button">
                <img src="/images/birdeye_logo.png" alt="Birdeye" class="button-image"/>
                <span class="button-text">Birdeye</span>
            </a>
        </div>

        <div class="buy-link">
            <a  style="background: black;"  href="https://dexscreener.com/solana/dnbjttuswitvycqbmf8nvqyjetj8ruwj7tkwznt3fwwy" target="_blank" rel="noopener noreferrer" class="buy-button">
<!--                <img src="/images/saber-logo.png" alt="Dexscreener" class="button-image"/>-->
                <svg class="button-image" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="#fff" fill-rule="evenodd" viewBox="0 0 252 300" focusable="false"><path d="M151.818 106.866c9.177-4.576 20.854-11.312 32.545-20.541 2.465 5.119 2.735 9.586 1.465 13.193-.9 2.542-2.596 4.753-4.826 6.512-2.415 1.901-5.431 3.285-8.765 4.033-6.326 1.425-13.712.593-20.419-3.197m1.591 46.886l12.148 7.017c-24.804 13.902-31.547 39.716-39.557 64.859-8.009-25.143-14.753-50.957-39.556-64.859l12.148-7.017a5.95 5.95 0 003.84-5.845c-1.113-23.547 5.245-33.96 13.821-40.498 3.076-2.342 6.434-3.518 9.747-3.518s6.671 1.176 9.748 3.518c8.576 6.538 14.934 16.951 13.821 40.498a5.95 5.95 0 003.84 5.845zM126 0c14.042.377 28.119 3.103 40.336 8.406 8.46 3.677 16.354 8.534 23.502 14.342 3.228 2.622 5.886 5.155 8.814 8.071 7.897.273 19.438-8.5 24.796-16.709-9.221 30.23-51.299 65.929-80.43 79.589-.012-.005-.02-.012-.029-.018-5.228-3.992-11.108-5.988-16.989-5.988s-11.76 1.996-16.988 5.988c-.009.005-.017.014-.029.018-29.132-13.66-71.209-49.359-80.43-79.589 5.357 8.209 16.898 16.982 24.795 16.709 2.929-2.915 5.587-5.449 8.814-8.071C69.31 16.94 77.204 12.083 85.664 8.406 97.882 3.103 111.959.377 126 0m-25.818 106.866c-9.176-4.576-20.854-11.312-32.544-20.541-2.465 5.119-2.735 9.586-1.466 13.193.901 2.542 2.597 4.753 4.826 6.512 2.416 1.901 5.432 3.285 8.766 4.033 6.326 1.425 13.711.593 20.418-3.197"></path><path d="M197.167 75.016c6.436-6.495 12.107-13.684 16.667-20.099l2.316 4.359c7.456 14.917 11.33 29.774 11.33 46.494l-.016 26.532.14 13.754c.54 33.766 7.846 67.929 24.396 99.193l-34.627-27.922-24.501 39.759-25.74-24.231L126 299.604l-41.132-66.748-25.739 24.231-24.501-39.759L0 245.25c16.55-31.264 23.856-65.427 24.397-99.193l.14-13.754-.016-26.532c0-16.721 3.873-31.578 11.331-46.494l2.315-4.359c4.56 6.415 10.23 13.603 16.667 20.099l-2.01 4.175c-3.905 8.109-5.198 17.176-2.156 25.799 1.961 5.554 5.54 10.317 10.154 13.953 4.48 3.531 9.782 5.911 15.333 7.161 3.616.814 7.3 1.149 10.96 1.035-.854 4.841-1.227 9.862-1.251 14.978L53.2 160.984l25.206 14.129a41.926 41.926 0 015.734 3.869c20.781 18.658 33.275 73.855 41.861 100.816 8.587-26.961 21.08-82.158 41.862-100.816a41.865 41.865 0 015.734-3.869l25.206-14.129-32.665-18.866c-.024-5.116-.397-10.137-1.251-14.978 3.66.114 7.344-.221 10.96-1.035 5.551-1.25 10.854-3.63 15.333-7.161 4.613-3.636 8.193-8.399 10.153-13.953 3.043-8.623 1.749-17.689-2.155-25.799l-2.01-4.175z"></path></svg>
                <span class="button-text">DexScreener</span>
            </a>
        </div>

        <div class="buy-link">
            <a  style="background: black;"  href="https://www.geckoterminal.com/solana/pools/DnBjTTUSWitVYCqbmf8nvqyjetJ8ruwj7TKwzNt3FwWy" target="_blank" rel="noopener noreferrer" class="buy-button">
                <img src="https://www.geckoterminal.com/images/favicon.ico" alt="GeckoTerminal" class="button-image"/>
                <span class="button-text">GeckoTerminal</span>
            </a>
        </div>
    </div>

</section>

<style>
    section {
        min-height: 100vh; /* Full viewport height */
        display: flex;
        flex-direction: column;
        justify-content: center; /* Centers content vertically */
        align-items: center; /* Centers content horizontally */
        padding: 2rem;
        text-align: center;
    }

    h2 {
        font-size: 1.8rem;
        margin-bottom: 1rem;
    }

    p {
        font-size: 18pt;
        line-height: 1.5;
        margin-bottom: 1.5rem;
    }

    .buy-links-container {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
    }

    .buy-button {
        display: flex;
        min-width: 75px;
        justify-content: space-around;
        padding: 10px 20px;
        background-color: #007bff; /* Customize your button color here */
        color: white;
        border-radius: 50px; /* Rounded look */
        text-decoration: none; /* Remove link underline */
        font-size: 1rem;
        font-weight: 500;
        box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.2);
        transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
    }

    .buy-button:hover {
        background-color: #0056b3; /* Darken on hover */
        transform: translateY(-2px); /* Lift effect */
        box-shadow: 0px 12px 16px rgba(0, 0, 0, 0.3);
    }

    .button-image {
        width: 24px; /* Adjust size as needed */
        height: 24px;
        margin-right: 8px;
    }

    .button-text {
        display: inline-block;
    }

    label {
        font-size: 1rem;
    }

    input[type="number"] {
        width: 80px;
        padding: 0.3rem;
        font-size: 1rem;
        text-align: center;
        border: 1px solid #ccc;
        border-radius: 4px;
    }

    button {
        padding: 0.5rem 1rem;
        font-size: 1rem;
        color: #fff;
        background-color: #007bff;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.3s ease;
    }

    button:hover {
        background-color: #0056b3;
    }
</style>
